<template>
    <div class="taker-details">
        <h6>{{nodeDetails.name}}</h6>
        <div
            v-for="(data, index) in nodeDetails.taker_data"
            :key="index"
        >
            <span v-if="index == 0"> Main: </span>
            <span v-else> Backup: </span>
            <p v-if="data.connected === true">
                <i class="el-icon-success text-success"></i><strong class="text-success">Taker connected</strong>
            </p>
            <p v-else>
                <i class="el-icon-error text-danger"></i> <strong class="text-danger">Taker not connected</strong>
            </p>

        </div>
        <div v-if="nodeDetails.taker_data.length > 0" class="zixi-conf">
            <hr>
            <strong>Zixi configuration: </strong>
            <p>Region: {{takerData.region || 'no region defined'}}</p>
            <div>
                <strong>Main:</strong>
                <p>Receiver name: {{takerData.main_receiver_name}}</p>
                <p>Ip: {{takerData.zixi_conf.main.ip}}</p>
                <p>Port: {{takerData.zixi_conf.main.port}}</p>
                <div v-if="takerData.source_protocol_type === 'zixi'">
                    <p v-if="takerData.redundancy_mode === 'IP_GATEWAY'">
                        Remote ID: {{takerData.zixi_conf.main.remote_id}}
                    </p>
                    <p v-else>
                        Remote ID (main): {{takerData.zixi_conf.main.remote_id}}
                    </p>
                </div>
                <p>Decryption type: {{takerData.zixi_conf.main.decryption_type}}</p>
            </div>
            <div v-if="takerData.redundancy_type === '1+1'">
                <strong>Backup:</strong>
                <p>Receiver name: {{backupData.backup_receiver_name}}</p>
                <p>Ip: {{takerData.zixi_conf.backup.ip}}</p>
                <p>Port: {{takerData.zixi_conf.backup.port}}</p>
                <div v-if="takerData.source_protocol_type === 'zixi'">
                    <p >Remote ID (backup): {{takerData.zixi_conf.backup.remote_id}}</p>
                </div>
                <p>Decryption type: {{takerData.zixi_conf.backup.decryption_type}}</p>
            </div>
            <p v-if="takerData.source_protocol_type === 'zixi'">
                Stream ID: {{takerData.zixi_conf.stream_id}}
            </p>
        </div>
        <actions-buttons
            v-if="(userIsAtLeastAdmin || userIsEntityAdmin(entityUid) )"
            :is-taker="true"
            :details="nodeDetails"
            :resource="resource"
            :resource-is-feed="resourceIsFeed"
            @watchModelStatus="watchModelStatus"
        ></actions-buttons>
    </div>
</template>

<script>
import ActionsButtons from './ResourceActionBtn/actions-buttons.vue';
import {mapGetters} from 'vuex';
export default {

    components: {
        ActionsButtons,
    },

    props: {
        nodeDetails: {
            type: Object,
            required: true
        },
        resource:{
            type: Object,
            default: null
        },
        resourceIsFeed:{
            type: Boolean,
        },
        entityUid:{
            type: String,
            required: true,
        }
    },

    computed: {
        ...mapGetters([
            'userIsAtLeastAdmin',
            'userIsEntityAdmin'
        ]),
        takerData(){
            if(this.nodeDetails.taker_data.length > 0){
                return this.nodeDetails.taker_data[0];
            }
        },
        backupData(){
            if(this.nodeDetails.taker_data.length === 2){
                return this.nodeDetails.taker_data[1];
            }
        }
    },

    mounted: function(){
    },

    methods: {
        watchModelStatus(model){
            this.$emit('watchModelStatus', model);
        }
    },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/page/Monitoring/takerDetails.vue